import { useEffect } from "react";
import BrandLogo10 from "../assets/images/brand-logo10.png";
import BrandLogo11 from "../assets/images/brand-logo11.png";
import BrandLogo12 from "../assets/images/brand-logo12.png";

import BrandLogo9 from "../assets/images/brand-logo9.png";

const BrandsMarqueSection = () => {
  useEffect(() => {
    document.querySelectorAll(".logos").forEach((logosContainer) => {
      const copy = logosContainer.querySelector(".logos-slide").cloneNode(true);
      logosContainer.appendChild(copy);
    });
  }, []);
  return (
    <>
      {/* <!-- ====================================== Brands Marquee Section ===================================== --> */}
      <div className="Marquee-main about-Marquee-main overflow-hidden">
        <h3 data-aos="fade-down">Trusted by Leading Company</h3>
        <div className="logos logos2">
          <div className="logos-slide">
            <div className="marquee__content">
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo9}
                  alt="brand-logo9"
                  width={180}
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo10}
                  alt="brand-logo10"
                  width={60}
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo11}
                  alt="brand-logo11"
                  width={180}
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo12}
                  alt="brand-logo12"
                  width={120}
                />
              </div>

              {/*
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo3}
                  alt="brand-logo3"
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo4}
                  alt="brand-logo4"
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo5}
                  alt="brand-logo5"
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo6}
                  alt="brand-logo6"
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo7}
                  alt="brand-logo7"
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo8}
                  alt="brand-logo8"
                />
              </div>
              <div className="marquee-img-main">
                <img
                  className="brand-logos"
                  src={BrandLogo7}
                  alt="brand-logo9"
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- =============================== Brands Marquee Section End =============================== --> */}
    </>
  );
};
export default BrandsMarqueSection;
